import { GA_MEASUREMENT_ID } from '../constants';

export function trackPageView(path) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}

export function trackEvent(action, params = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', action, params);
}
